import { Component, Input, OnChanges, SimpleChange, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-custom-tab',
  templateUrl: './custom-tab.component.html',
  styleUrls: ['./custom-tab.component.css']
})
export class CustomTabComponent implements OnChanges {
  @Input() tabList: any[];
  @Output() clickOnAction = new EventEmitter();
  public activeUrl: string;
  constructor(private router: Router) {

  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    this.activeUrl = this.router.url;
    for (let propName in changes) {
      let changedProp = changes[propName];
      this.tabList = changedProp.currentValue
    }
  }

  changeTab(templateUrl) {
    this.router.navigate([templateUrl])

  }
  callOwnFunction(name) {
    this.clickOnAction.emit(name);
  }
}


// WEBPACK FOOTER //
// /var/www/staging.theprintlife.com/src/app/mnt-master/custom-tab/custom-tab.component.ts